module.exports = __webpack_public_path__ + "img/config_carousel_02.a6bd4aca.jpg";